<div class="container-fluid">
  <div class="my-5 ms-0 ms-md-2 ms-lg-4 ms-xl-5">
    <div class="row">
      <div class="col-12 col-md-9 col-xl-6">
        <h1 class="mb-4 pre-wrap"
            [translate]="'AUTH.CREATE-ACCOUNT.PAGE-TITLE'">
        </h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-9 col-xl-6">
        <p class="mb-5 pre-wrap"
           [translate]="'AUTH.CREATE-ACCOUNT.PAGE-DESCRIPTION'">
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-7 col-xl-5">
        <div class="card shadow-lg border-0 mb-4">
          <div class="card-body py-4">
            <form name="form"
                  autocomplete="off"
                  [formGroup]="registrationForm">
              <app-registration-form [isFormSubmitted]="isFormSubmitted"></app-registration-form>

              <div class="text-secondary mb-4">
                <span [translate]="'AUTH.CREATE-ACCOUNT.CUSTOMER-READ-AND-ACCEPTED-NOTE.BY-CLICKING-NEXT-I-ACCEPT'">
                </span>&nbsp;<a href="{{ 'SHARED.LINKS.DISCLAIMER.LINK' | translate }}"
                   target="_blank"
                   [translate]="'AUTH.CREATE-ACCOUNT.CUSTOMER-READ-AND-ACCEPTED-NOTE.DISCLAIMER'">
                </a>&nbsp;<span [translate]="'AUTH.CREATE-ACCOUNT.CUSTOMER-READ-AND-ACCEPTED-NOTE.AND'">
                </span>&nbsp;<a href="{{ 'SHARED.LINKS.PRIVACY-POLICY.LINK' | translate }}"
                   target="_blank"
                   [translate]="'AUTH.CREATE-ACCOUNT.CUSTOMER-READ-AND-ACCEPTED-NOTE.PRIVACY-POLICY'"></a>.
              </div>
              <div class="d-flex justify-content-end">
                <button class="btn btn-cta btn-lg px-4"
                        (click)="registerCustomer()">
                  {{ 'AUTH.CREATE-ACCOUNT.CREATE-ACCOUNT-BUTTON-TEXT' | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
